<app-music-collection-navbar></app-music-collection-navbar>
<router-outlet></router-outlet>
